import React, { useState, useEffect } from 'react'

import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Auth } from 'aws-amplify'

import { Layout, Menu, Modal } from 'antd'
import {
  PoweroffOutlined,
  GlobalOutlined,
  GatewayOutlined,
  NodeIndexOutlined,
  FormOutlined,
  EditOutlined,
} from '@ant-design/icons'
import { BiMapAlt, BiUser } from 'react-icons/bi'
import { FiUsers } from 'react-icons/fi'
import { HiOutlineDocumentDuplicate } from 'react-icons/hi'
import { RiFileEditLine } from 'react-icons/ri'

import { setSectionSelected } from 'store/global/sectionSelected'
import { updateAuthData, LOGED_OUT } from 'store/auth/auth'

import { setSideBarInfo } from 'store/global/map/sideBarInfo'
import { setLayersInfo } from 'store/global/map/layersInfo'

import Countries from 'components/Countries/Countries'
import GeoLogo from '../../assets/geocreator.svg'
import './Sidebar.css'

const Sider = Layout.Sider

function Sidebar(props) {
  const dispatch = useDispatch()
  const history = useHistory()
  // const location = useLocation()
  const sectionSelected = useSelector((state) => state.sectionSelected.data)

  const [isModalCountriesVisible, setIsCountriesModalVisible] = useState(false)
  const [collapsed, setCollapsed] = useState(false)

  useEffect(() => {
    // console.log(history)
    history.location.pathname === '/' ? dispatch(setSectionSelected('GEOCREATOR')) : null
    history.location.pathname === '/geocreator' ? dispatch(setSectionSelected('GEOCREATOR')) : null
    history.location.pathname === '/map' ? dispatch(setSectionSelected('MAP')) : null
    history.location.pathname === '/user-info' ? dispatch(setSectionSelected('USER_INFO')) : null
    history.location.pathname === '/documents' ? dispatch(setSectionSelected('DOCUMENTS')) : null
    history.location.pathname === '/users-manager' ? dispatch(setSectionSelected('USERS_MANAGER')) : null
    history.location.pathname === '/unifilar-editor' ? dispatch(setSectionSelected('UNIFILAR_EDITOR')) : null
  }, [])

  return (
    <Sider
      // className="side-bar-style"
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      collapsedWidth={50}
      width={152}
      style={{
        color: 'rgba(255,255,255,.65)',
        height: '100%',
        background: '#1a2022',
      }}
    >
      <Modal
        title="Select a country"
        visible={isModalCountriesVisible}
        footer={null}
        centered={true}
        className="map-selection-modal"
        onCancel={() => {
          setIsCountriesModalVisible(false)
        }}
        destroyOnClose={true}
      >
        <Countries
          onSelect={() => {
            props.setViewState()
            dispatch(setSectionSelected('MAP'))
            setIsCountriesModalVisible(false)
          }}
        />
      </Modal>

      <Menu
        theme="dark"
        mode="inline"
        style={{ marginTop: '25px', borderRight: 0, background: '#1a2022' }}
        selectedKeys={[sectionSelected]}
      >
        <Menu.Item
          key="COUNTRIES"
          icon={<GlobalOutlined />}
          onClick={() => {
            dispatch(setSectionSelected('COUNTRIES'))
            setIsCountriesModalVisible(true)
          }}
        >
          Scope
        </Menu.Item>
        {props.user_tools ? (
          props.user_tools.includes('layers') ? (
            <Menu.Item
              key="MAP"
              icon={<BiMapAlt />}
              onClick={() => {
                dispatch(setSectionSelected('MAP'))
                history.push('/map')
              }}
            >
              Layers
            </Menu.Item>
          ) : null
        ) : (
          <Menu.Item
            key="MAP"
            icon={<BiMapAlt />}
            onClick={() => {
              dispatch(setSectionSelected('MAP'))
              history.push('/map')
            }}
          >
            Layers
          </Menu.Item>
        )}
        {props.user_tools ? (
          props.user_tools.includes('geocreator') ? (
            <Menu.Item
              key="GEOCREATOR"
              // icon={<EditOutlined />}
              icon={
                <img
                  src={GeoLogo}
                  className="sidebar-img-icons"
                  style={
                    sectionSelected === 'GEOCREATOR'
                      ? {
                          filter:
                            'invert(100%) sepia(99%) saturate(0%) hue-rotate(187deg) brightness(104%) contrast(101%)',
                        }
                      : null
                  }
                />
              }
              onClick={() => {
                history.location.pathname === '/map' ? dispatch(setLayersInfo(props.getMapLayers())) : null
                dispatch(setSectionSelected('GEOCREATOR'))
                history.push('/geocreator')
              }}
            >
              Geocreator
            </Menu.Item>
          ) : null
        ) : null}
        <Menu.Item
          key="USER_INFO"
          icon={<BiUser />}
          onClick={() => {
            history.location.pathname === '/map' ? dispatch(setLayersInfo(props.getMapLayers())) : null
            dispatch(setSectionSelected('USER_INFO'))
            history.push('/user-info')
          }}
        >
          User Info
        </Menu.Item>

        {props.user_type === 'admin' ? (
          <Menu.Item
            key="DOCUMENTS"
            icon={<HiOutlineDocumentDuplicate />}
            onClick={() => {
              history.location.pathname === '/map' ? dispatch(setLayersInfo(props.getMapLayers())) : null
              dispatch(setSectionSelected('DOCUMENTS'))
              history.push('/documents')
            }}
          >
            Documents
          </Menu.Item>
        ) : null}
        {props.user_type === 'admin' ? (
          <Menu.Item
            key="USERS_MANAGER"
            icon={<FiUsers />}
            onClick={() => {
              history.location.pathname === '/map' ? dispatch(setLayersInfo(props.getMapLayers())) : null
              dispatch(setSectionSelected('USERS_MANAGER'))
              history.push('/users-manager')
            }}
          >
            Users
          </Menu.Item>
        ) : null}

        {props.user_type === 'admin' ? (
          <Menu.Item
            key="UNIFILAR_EDITOR"
            icon={<RiFileEditLine />}
            onClick={() => {
              history.location.pathname === '/map' ? dispatch(setLayersInfo(props.getMapLayers())) : null
              dispatch(setSectionSelected('UNIFILAR_EDITOR'))
              history.push('/unifilar-editor')
            }}
          >
            Unifilar Editor
          </Menu.Item>
        ) : null}

        <Menu.Item
          key="LOG_OUT"
          icon={<PoweroffOutlined style={{ color: '#a65e44' }} />}
          style={{ position: 'absolute', bottom: '50px', width: '100%' }}
          onClick={() => {
            window.location.reload()
            Auth.signOut().then(() => {
              dispatch(
                updateAuthData({
                  authStatus: LOGED_OUT,
                  jwtToken: '',
                  email: '',
                  emailVerified: false,
                  groups: [],
                }),
              )
            })
          }}
        >
          Log Out
        </Menu.Item>
      </Menu>

      <div
        style={{
          position: 'absolute',
          bottom: '24px',
          width: '100%',
          textAlign: 'center',
          display: 'none',
        }}
      >
        <a
          className="logout-btn"
          onClick={() => {
            window.location.reload()
            Auth.signOut().then(() => {
              dispatch(
                updateAuthData({
                  authStatus: LOGED_OUT,
                  jwtToken: '',
                  email: '',
                  emailVerified: false,
                  groups: [],
                }),
              )
            })
          }}
        >
          <PoweroffOutlined style={{ color: '#a65e44', marginRight: '8px' }} />
          Log out
        </a>
      </div>
    </Sider>
  )
}

export default Sidebar
